<template>
  <div id="contents">
    <div id="news" class="page_contents">
      <div class="page_header">
        <h1 class="page_header_title">
          <img src="../assets/img/news/title.png" width="215" alt="NEWS" />
          <span>お知らせ</span>
        </h1><!-- .top_sec_title -->
      </div><!-- .page_header -->

      <div id="news_contents" class="page_main_contents">
        <div id="news_index">
          <!-- 以下、loop -->
          <div v-for="news in news_list" :key="news.post_id" v-bind:class="{ 'new' : news.is_new }" class="news_list">
            <h3>{{ news.date }}</h3>
            <p><router-link v-bind:to="{name: 'news_show', params: {id: news.post_id}}">{{ formatted_title(news.title) }}</router-link></p>
          </div><!-- .news_list -->
        </div><!-- #news_index -->

      </div><!-- #news_contents -->

    </div><!-- #news -->

  </div><!-- #contents -->
</template>

<script>
export default {
  name: 'news_index',
  data(){
    return {
      api_url: this.$parent.api_base_url+'/api/news/index.php',
      news_list: null,
      error: null
    }
  },
  methods: {
    fetch_news_list(){
      this.$axios
        .get(this.api_url)
        .then(response => {
          this.news_list = response.data.item
        })
        .catch(error => {
          console.log(error)
          this.error = true
        })
        .finally(() => this.$emit('page_fade'))
    },
    formatted_title(title) {
      return title.replace(/<br\s*\/?>/g, '\n');
    }
  },
  mounted () {
    this.fetch_news_list()
    $("#contents_wrap").css("min-height", "unset");
  }
}
</script>



// WEBPACK FOOTER //
// src/components/news_index.vue